import {Component, EventEmitter, Input, Output, OnInit, OnDestroy} from '@angular/core';
import {KeyboardService} from '../../services';
import {Subscription} from 'rxjs/Subscription';
import {ContentDetail} from '../../model/typings/content.types';

@Component({
  selector: 'cpui-image-inspire',
  templateUrl: './image-inspire.component.html',
  styleUrls: ['./image-inspire.component.scss']
})
export class ImageInspireComponent implements OnInit, OnDestroy {
  inspireImageStyle: {};
  inspireImageHref: string;
  triggerImageFetch = false;
  @Input() hideInspirationTrigger = false;
  @Input() blurInspiration = false;
  @Input() blurInspirationMobile = false;
  @Input() inspireContentDetail?: ContentDetail;
  @Input() inspireTitle?: string;
  @Input() inspireDescription?: string;
  @Input() imageAssets: any[];
  @Output() inspirationVisibilityChange = new EventEmitter();

  showInspirationValue = false;
  keyupSubscription: Subscription;

  @Input()
  get showInspiration() {
    return this.showInspirationValue;
  }

  set showInspiration(showInspiration: boolean) {
    this.showInspirationValue = showInspiration;

    if (this.showInspirationValue) {
      this.fetchImages(100);
    }
  }

  constructor(private keyboardService: KeyboardService) {
  }

  ngOnInit() {
    this.keyupSubscription = this.keyboardService.onDocumentKeyupObservable().subscribe((event) => this.onDocumentKeyup(event));
  }

  ngOnDestroy() {
    if (this.keyupSubscription) {
      this.keyupSubscription.unsubscribe();
    }
  }

  fetchImages(delay = 0): void {
    if (!this.triggerImageFetch) {
      setTimeout(() => {
        this.triggerImageFetch = true;
      }, delay);
    }
  }

  onDocumentKeyup(keyupEvent: KeyboardEvent): void {
    if (this.showInspirationValue || this.inspireImageHref) {
      const isEscape = (keyupEvent.key === 'Escape' || keyupEvent.key === 'Esc');

      if (isEscape) {
        this.collapseInspireImage();
        this.closeInspiration();
      }
    }
  }

  closeInspiration(): void {
    this.showInspirationValue = false;
    this.collapseInspireImage();
    this.inspirationVisibilityChange.emit(this.showInspirationValue);
  }

  toggleInspiration(): void {
    this.showInspirationValue = !this.showInspirationValue;
    this.collapseInspireImage();
    this.inspirationVisibilityChange.emit(this.showInspirationValue);
  }

  expandInspireImage(inspireImageHref: string): void {
    this.inspireImageHref = inspireImageHref;
    this.inspireImageStyle = inspireImageHref ? {'background-image': 'url(' + inspireImageHref + ')'} : {};
  }

  collapseInspireImage(): void {
    this.inspireImageHref = null;
  }

  getImageRotation(rotation: number): any {
    return {'transform': `rotate(${rotation || 0}deg)`};
  }

}



// WEBPACK FOOTER //
// ./src/app/components/image-inspire/image-inspire.component.ts